import React from 'react';

import styled from 'styled-components';

export const OuterWrapper = styled.div`
  position: relative;
  height: 48px;
`;

export const Wrapper = styled.div<{ open: boolean }>`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  max-height: 362px;
  display: flex;
  flex-flow: column nowrap;
  border-radius: 4px;
  color: var(--colorBlueGray1100);
  transition: ${({ open }) => (open ? 'z-index 0s ease-in-out 0s' : 'z-index .2s ease-in-out .2s')};
  z-index: ${({ open }) => (open ? '99' : 'unset')};
`;

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: var(--colorWhite);
  align-items: center;
  border: 1px solid rgb(213, 215, 216);
  padding: 4px 8px;
  border-radius: 4px;
  width: 100%;
  height: 46px;
  min-height: 46px;
  cursor: pointer;
  margin-bottom: 4px;
`;

export const Text = styled.span<{ active: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 18px;
  color: ${({ active }) => (active ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray700)')};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  span {
    margin-left: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    line-height: 1.3;
  }
`;

export const Icon = styled.div<{ open: boolean }>`
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  transform-origin: center;
  height: 24px;
  width: 24px;
  transition: transform 0.2s ease-in-out;
`;

export const List = styled.div<{ open: boolean }>`
  overflow: auto;
  padding-bottom: ${({ open }) => (open ? '22px' : '0')};
  background-color: var(--colorWhite);
  border-radius: 4px;
  box-shadow: ${({ open }) =>
    open
      ? '0px 0px 15px -7px rgba(0, 0, 0, 0.32), 0px 0px 46px 8px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.24)'
      : 'none'};
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
`;

export const ListItem = styled.div<{ disabled: boolean }>`
  border-bottom: 1px solid var(--colorBlueGray100);
  padding: 4px 12px;
  min-height: 48px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
    margin-right: 8px;
    line-height: 1.3;
  }
`;

export const Circle = styled.div<{ selected: boolean }>`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  text-align: center;
  line-height: 29px;
  margin-left: auto;
  border: 1px solid;
  border-color: ${({ selected }) =>
    selected ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray100)'};
  background-color: ${({ selected }) => (selected ? 'var(--colorBlueGray1200)' : 'transparent')};
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  svg {
    width: 16px;
    height: 16px;
    opacity: ${({ selected }) => (selected ? '1' : '0')};
    transition: opacity 0.2s ease-in-out;
  }
`;

export const StorybookWrapper = styled.div`
  width: 500px;
`;
